















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { setStore, getStore, removeStore, decrypt } from '../../../utils/utils'
import { namespace } from 'vuex-class'
const login = namespace('login')
import jsmd5 from 'js-md5'
@Component
export default class PayResultShow extends Vue {
  @login.Action queryUuid
  get isApp() {
    // return this.$store.state.fromApp
    return getStore('setAppStatus')
  }
  appStatus: any = false

  created() {
    this.appStatus = getStore('setAppStatus')
  }

  btnClick(val) {
    // error-installmentPayAir   success-billManage
    // 1 重新选择支付方式   2立即开通  3查看逾期账单
    if (val == '1') {
      this.$router.replace('/quotaManageIndex')
    } else if (val == 'success') {
      setStore('billMonth', this.$route.query.billMonth) //作用：账单详情判断当前月是否能还款（按钮是否能点击）
      this.$router.replace({
        path: '/billManage',
        query: { billMonth: this.$route.query.billMonth },
      })
    } else if (val == '2') {
      // 存储标识，用于判断从支付页面(1)进入的开通结果页面还是首页进入的
      setStore('openLinesFlag', '1')
      this.$router.replace('/quotaapplication')
    } else {
      this.$router.replace({
        path: '/billManage',
        query: {
          billMonth: this.$moment(this.$route.query.billMonth).format('YYYYMM'),
        },
      })
    }
  }
  backApp() {
    let path: any = this.$route.query.merPageUrl
    let tradeInfo = JSON.parse(getStore('tradeInfo'))
    console.log(path, 'path', tradeInfo)

    window.location.replace(decodeURIComponent(path))
    // console.log('回到app....')
  }
  backLogin() {
    removeStore('tradeInfo')
    // window.location.replace('/')
    let userInfoData: any = getStore('userInfo') ? JSON.parse(getStore('userInfo')) : {}
    // let passWord: any = getStore('passWord') ? decrypt(getStore('passWord')) : ''
    let params: any = {
      certId: userInfoData.certId,
      //   passWord: jsmd5(passWord) || '',
    }

    this.queryUuid(params).then((res: any) => {
      if (res && res['code'] == 502) {
        // 存储用户信息
        let userInfo = {
          custId: res.data.custId, // 编号
          certId: res.data.certId, // 身份证号
          custName: res.data.custName, // 用户姓名
          accNo: res.data.accNo, // 银行卡号
          accMobile: res.data.accMobile, //预留手机号
          mobile: res.data.mobile, //手机号
          password: res.data.password, // 支付密码
          credId: res.data.credId, // 额度id
        }
        setStore('token', res.data.token)
        if (res.data.picture) {
          setStore('userImg', res.data.picture) // 存储 用户图片
        } else {
          setStore('userImg', '1.png') // 默认第一张
        }
        setStore('userInfo', JSON.stringify(userInfo))
        this.$router.push({
          path: '/quotaManageIndex',
          query: { flag: 'success' },
        })
      } else if (res && res['code'] == 200) {
        //   this.$toast('请先开通东航分期付')
        // this.$router.push('/home')
        this.$router.replace('/home')
      } else if (res && res['code'] == 501) {
        //   人工审批中
        // this.$router.push({
        //   path: '/resultShow',
        //   query: { type: res['code'], msg: res.msg || '人工审批中', flag: 'login' },
        // })
        this.$router.replace('/home')
      } else if (res && res['code'] == 503) {
        this.$router.replace('/home')
        // this.$router.push({
        //   path: '/resultShow',
        //   query: { type: res['code'], msg: res.msg || '申请失败', flag: 'login' },
        // })
      }
    })
  }
}
